import React, { useMemo } from "react";
import ColorIndicator from "./ColorIndicator";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useInventory } from "../hooks/useInventory";
import { T } from "./T";

const PoleTable = () => {
  const { dbPoles, projectLoading, poleset } = useInventory();
  const allowedLengths = poleset.poles.map((p) => p.length);
  const colors = poleset.poles.map((p) => p.color);

  const polesGroupedByLength = useMemo(() => {
    return allowedLengths.map((length, index) => {
      const number = dbPoles.reduce(
        (acc, pole) => (pole.length === length ? acc + 1 : acc),
        0
      );

      return {
        length,
        number,
        color: colors[index],
      };
    });
  }, [allowedLengths, dbPoles, colors]);

  const totalGroupedPoles = polesGroupedByLength.reduce(
    (acc, cur) => acc + cur.number,
    0
  );
  const otherLengths = dbPoles.length - totalGroupedPoles;

  if (projectLoading) return null;

  return (
    <TableContainer
      component={Paper}
      sx={{
        backgroundColor: "primary.light",
        color: "primary.contrastText",

        "& th": {
          fontWeight: "bold",
          backgroundColor: "primary.main",
        },

        "& td": {
          fontWeight: "bold",
        },
      }}
    >
      <Table aria-label="Pole Table">
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <T str="Color" />
            </TableCell>
            <TableCell align="left">
              <T str="Length" />
            </TableCell>
            <TableCell align="left">#</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {polesGroupedByLength?.map((pole) => (
            <TableRow key={pole.length}>
              <TableCell>
                <ColorIndicator color={pole.color} />
              </TableCell>
              <TableCell>{`${pole.length} m`}</TableCell>
              <TableCell>{pole.number}</TableCell>
            </TableRow>
          ))}
          {otherLengths > 0 && (
            <TableRow key={"other"}>
              <TableCell>
                <ColorIndicator color={"#888888"} />
              </TableCell>
              <TableCell>{<T str="Other lengths" />}</TableCell>
              <TableCell>{otherLengths}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PoleTable;
